const isNullOrUndefined = (value) => value === undefined || value === null;

export default isNullOrUndefined;
